module.exports = __webpack_public_path__ + "static/media/infinity.8e985779.svg";